import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Env } from '../../../../environments/environment.model';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentProvider {
  get(): Env {
    return environment;
  }
}
